import { Box, Button } from 'braid-design-system';
import React from 'react';

import BoundedBox from '../BoundedBox/BoundedBox';

import * as styles from '../NavigationButton/style.css';

const SubmitButton = () => (
  <Box className={styles.end}>
    <BoundedBox width={150}>
      <Button type="submit">Submit</Button>
    </BoundedBox>
  </Box>
);

export default SubmitButton;
